/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    h3: "h3",
    h4: "h4"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Description"
    }), "\n", _jsx(_components.p, {
      children: "Badge generates a small badge on its child(ren), or can be a inline/standalone badge."
    }), "\n", _jsx(_components.h3, {
      children: "Badge variants"
    }), "\n", _jsx(_components.h4, {
      children: "Information Badge"
    }), "\n", _jsx(_components.p, {
      children: "Can be used to describe or inform about new activity or features in our applications. The label can be placed on top of element backgrounds or inline with text within cells."
    }), "\n", _jsx(_components.p, {
      children: "The logic of how long it should be visible would differ from case to case, so that's up to the designer."
    }), "\n", _jsx(_components.h4, {
      children: "Notification Badge"
    }), "\n", _jsx(_components.p, {
      children: "The notification badge has a very limited use.\nArea of use is limited as of now, as a counter of messages in the message's center."
    }), "\n", _jsx(_components.p, {
      children: "We only show single digits in the counter. If there are more notifications than that, we show “9+”."
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
